$(document).on('click', '.js-copy', function () {
	let $target = $($(this).data('copy'));
	let text = $target.text();

	let temp = $('<textarea>');
	$('body').append(temp);
	temp.val(text).select();
	document.execCommand('copy');
	temp.remove();

	$(this).text('Copied!');
	setTimeout(() => {
		$(this).text('Copy');
	}, 1500);
});


$('#subscribe-form').on('submit', function(e) {
	const referral = $('#referral_code').val().trim();

	if (referral.length) {
		e.preventDefault();

		$.post('/buy-credits/check-referral-code/', { referral_code: referral }, function(res) {
			if (res.status === 'success') {
				let isValid = true;

				$('#subscribe-form [data-validation]').each(function () {
					$(this).validate(function(valid, elem) {
						console.log('Element '+elem.name+' is '+( valid ? 'valid' : 'invalid'));

						console.log(valid);
						if (!valid) {
							isValid = false;
						}
					});
				});

				console.log(isValid);

				if (isValid) {
					$('#subscribe-form')[0].submit();
				}
			} else {
				alert('The referral code entered is not valid.');
			}
		}, 'json');
	}
});